export default __webpack_public_path__ + "static/ssn-input-a84530617b857540031d11a2cfb8dd03.gif";